<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <div class="qam-calc-box">
      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field v-model="flN" :counter="10" :rules="flnRules" :disabled="progress" label="Flugnummer"
            required></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-dialog attach v-model="datepickerfln" :close-on-content-click="false" transition="scale-transition"
            :disabled="progress" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="computedDateFormatted" label="Flugdatum" persistent-hint :disabled="progress"
                prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="flD" :first-day-of-week="1" locale="de-DE" no-title
              @input="datepickerfln = false"></v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="4">
          <v-btn style="margin-top: 15px;" id="search-fl" block :disabled="!valid || progress" color="success"
            class="mr-4" @click="validate">
            Flug suchen
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"><v-btn block x-small @click="goToMan" :disabled="progress">Flug ohne Flugnummer
            suchen?</v-btn></v-col>
      </v-row>
    </div>
    <template v-if="progress">
      <div id="pass20" v-show="selectedDiv == '20' || pass20">
        <v-row>
          <v-col cols="12">
            <h2 class="qam-calc-h2" v-if="dataFS.res == 'fs'">
              Möchten Sie für diesen Flug Entschädigungsmöglichkeiten prüfen?
            </h2>
            <h2 class="qam-calc-h2" v-if="dataFS.res == 'ma' && !manRunSs">
              Wir finden Ihren Flug leider nicht in unserer Datenbank. Bitte
              geben Sie die Daten zu Ihrem Flug manuell ein.
            </h2>
            <h2 class="qam-calc-h2" v-if="dataFS.res == 'ma' && manRunSs">
              Bitte geben Sie den Start- und Zielflughafen Ihrer Reise an und
              wählen Sie die Art der aufgetretenen Flugunregelmäßigkeit aus.
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-text>
                <h3 v-if="dataFS.res == 'fs'">
                  {{
                    dataFS.airline.name +
                    " - " +
                    flN +
                    " am " +
                    computedDateFormatted
                  }}
                </h3>
                <h3 v-if="dataFS.res == 'ma' && !manRunSs">
                  {{ flN + " am " + computedDateFormatted }}
                </h3>
                <div class="text--primary">
                  <v-row v-if="dataFS.res == 'fs'">
                    <v-col cols="12" sm="6">
                      <v-icon>flight_takeoff</v-icon><br />
                      <h3>
                        {{
                          dataFS.airports.airportSName +
                          " (" +
                          dataFS.airports.airportSC +
                          ")"
                        }}
                      </h3>
                      <p>{{ fs4DisplayDep }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-icon>flight_land</v-icon><br />
                      <h3>
                        {{
                          dataFS.airports.airportTName +
                          " (" +
                          dataFS.airports.airportTC +
                          ")"
                        }}
                      </h3>
                      <p>{{ fs4DisplayArr }}</p>
                    </v-col>
                  </v-row>
                  <v-row v-if="dataFS.res == 'ma'">
                    <v-col cols="12" sm="6">
                      <v-autocomplete attach v-model="manDepAir" :items="airports1" :loading="isLoading"
                        :search-input.sync="search1" :disabled="pass20" color="blue-grey lighten-2"
                        label="Startflughafen" clearable flat item-text="fsidAN" item-value="item" hide-no-data
                        hide-details prepend-icon="flight_takeoff" return-object>
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME
                              ">{{ data.item.FSID }} -
                              {{ data.item.airportNAME }}
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-autocomplete attach v-model="manArrAir" :items="airports2" :loading="isLoading"
                        :disabled="pass20" :search-input.sync="search2" color="blue-grey lighten-2"
                        label="Zielflughafen" clearable flat item-text="fsidAN" item-value="item" hide-no-data
                        hide-details prepend-icon="flight_land" return-object>
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME
                              ">{{ data.item.FSID }} -
                              {{ data.item.airportNAME }}
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-select attach v-model="data.case" :items="cases" :disabled="pass1F"
                        :menu-props="{ top: true, offsetY: true }" prepend-icon="report_problem"
                        label="Welches Problem ergab sich bei diesem Flug?"></v-select>
                    </v-col>
                  </v-row>
                  <template v-if="
                    data.case == 'Flugverspätung' ||
                    data.case == 'Verpasster Anschlussflug'
                  ">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-dialog v-model="dateMenuDep" :close-on-content-click="false" :nudge-right="40"
                          :disabled="pass1F" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="computedDateFormattedDepDate" label="Geplantes Ankunftsdatum"
                              prepend-icon="event" readonly :disabled="pass1F" v-on="on"></v-text-field>
                          </template>
                          <v-date-picker :disabled="pass1F" :first-day-of-week="1" locale="de-DE" v-model="depDate1"
                            @input="dateMenuDep = false"><v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dateMenuDep = false">Abbrechen</v-btn>
                            <v-btn text color="primary"
                              @click="$refs.dateMenuDep.save(depDate1)">Ok</v-btn></v-date-picker>
                        </v-dialog>
                        <v-dialog attach ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                          :disabled="pass1F" :return-value.sync="time1" transition="scale-transition" offset-y
                          max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="time1" :disabled="pass1F" label="Geplante Ankunftszeit"
                              prepend-icon="access_time" readonly v-on="on"></v-text-field>
                          </template>
                          <v-time-picker v-if="menu1" v-model="time1" :disabled="pass1F" format="24hr" full-width
                            @click:minute="$refs.menu1.save(time1)"></v-time-picker>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-dialog attach v-model="dateMenuArr" :close-on-content-click="false" :nudge-right="40"
                          :disabled="pass1F" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="computedDateFormattedArrDate" label="Tatsächliches Ankunftsdatum"
                              prepend-icon="event" :disabled="pass1F" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="arrDate1" :first-day-of-week="1" locale="de-DE"
                            @input="dateMenuArr = false" :disabled="pass1F"><v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dateMenuArr = false">Abbrechen</v-btn>
                            <v-btn text color="primary"
                              @click="$refs.dateMenuArr.save(arrDate1)">Ok</v-btn></v-date-picker>
                        </v-dialog>
                        <v-dialog attach ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                          :disabled="pass1F" :return-value.sync="time2" transition="scale-transition" offset-y
                          max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="time2" label="Tatsächliche Ankunftszeit" :disabled="pass1F"
                              prepend-icon="access_time" readonly v-on="on"></v-text-field>
                          </template>
                          <v-time-picker v-if="menu2" v-model="time2" :disabled="pass1F" format="24hr" full-width
                            @click:minute="$refs.menu2.save(time2)"></v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </template>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn id="confirm-data-fl" block @click="confirmF1Flight" :disabled="pass1F || data.case == ''" text
                  color="teal darken-1">
                  Flugdaten bestätigen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <template v-if="pass1F && flOODE && !l4ZB">
          <v-row>
            <v-col cols="12">
              <v-btn block color="success" class="mr-4" @click="sZB('y')">Zubringerflug hinzufügen
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn block color="success" class="mr-4" @click="sZB('n')">Ohne Zubringerflug fortfahren
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template>
          <div v-if="l4ZB && !passZB" class="qam-calc-box">
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="flnZB" :counter="10" :rules="flnRules" :disabled="zubiFLS" label="Flugnummer"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-dialog attach v-model="datepickerflnZB" :close-on-content-click="false" transition="scale-transition"
                  :disabled="zubiFLS" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="computedDateFormattedZB" label="Flugdatum" persistent-hint
                      :disabled="zubiFLS" prepend-icon="event" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" locale="de-DE" v-model="flDZB" no-title
                    @input="datepickerflnZB = false"></v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn id="search-fl--zb" block :disabled="zubiFLS" color="success" class="mr-4" @click="checkZB">
                  Zubringerflug suchen
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="zubiFLS">
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <h3 v-if="dataFSZB.res == 'fs'">
                    {{
                      dataFSZB.airline.name +
                      " - " +
                      flnZB +
                      " am " +
                      computedDateFormatted
                    }}
                  </h3>
                  <h3 v-if="dataFSZB.res == 'ma'">
                    {{ flnZB + " am " + computedDateFormatted }}
                  </h3>
                  <div class="text--primary">
                    <v-row v-if="dataFSZB.res == 'fs'">
                      <v-col cols="12" sm="6">
                        <v-icon>flight_takeoff</v-icon><br />
                        <h3>
                          {{
                            dataFSZB.airports.airportSName +
                            " (" +
                            dataFSZB.airports.airportSC +
                            ")"
                          }}
                        </h3>
                        <p>{{ fs4DisplayDepZB }}</p>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-icon>flight_land</v-icon><br />
                        <h3>
                          {{
                            dataFSZB.airports.airportTName +
                            " (" +
                            dataFSZB.airports.airportTC +
                            ")"
                          }}
                        </h3>
                        <p>{{ fs4DisplayArrZB }}</p>
                      </v-col>
                    </v-row>
                    <v-row v-if="dataFSZB.res == 'ma'">
                      <v-col cols="12" sm="6">
                        <v-autocomplete attach v-model="manDepAirZB" :items="airports3" :loading="isLoading"
                          :disabled="pass20" :search-input.sync="search3" color="blue-grey lighten-2"
                          label="Startflughafen" clearable flat item-text="fsidAN" item-value="data.item" hide-no-data
                          hide-details prepend-icon="flight_takeoff" return-object>
                          <template v-slot:item="data">
                            <template>
                              <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME
                                ">{{ data.item.FSID }} -
                                {{ data.item.airportNAME }}
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-autocomplete attach v-model="manArrAirZB" :items="airports4" :loading="isLoading"
                          :disabled="pass20" :search-input.sync="search4" color="blue-grey lighten-2"
                          label="Zielflughafen" clearable flat item-text="fsidAN" item-value="item" hide-no-data
                          hide-details prepend-icon="flight_land" return-object>
                          <template v-slot:item="data">
                            <template>
                              <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME
                                ">{{ data.item.FSID }} -
                                {{ data.item.airportNAME }}
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn id="confirm-data-fl--zb" block @click="setZB" :disabled="passZB || (manArrAirZB == '' && manDepAirZB == '')
                    " text color="teal darken-1">
                    Zubringerflug bestätigen
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <template v-if="
          (pass1F && !passAN && !l4AN && passZB && flOODE) ||
          (pass1F && !passAN && !l4AN && !flOODE)
        ">
          <v-row>
            <v-col cols="12">
              <v-btn id="fl-add-xtra" block color="success" :disabled="passAN" class="mr-4" @click="sAN">Anschlussflug
                hinzufügen
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn block color="success" class="mr-4" @click="start20" id="fl-no-xtra">Ohne Anschlussflug fortfahren
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template>
          <div v-if="l4AN && !passAN" class="qam-calc-box">
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="flnAN" :counter="10" :rules="flnRules" :disabled="anschFLS" label="Flugnummer"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-dialog attach v-model="datepickerflnAN" :close-on-content-click="false" transition="scale-transition"
                  :disabled="anschFLS" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="computedDateFormattedAN" label="Flugdatum" persistent-hint
                      :disabled="anschFLS" prepend-icon="event" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" locale="de-DE" v-model="flDAN" no-title
                    @input="datepickerflnAN = false"></v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn id="search-fl--xtra" block :disabled="anschFLS" color="success" class="mr-4" @click="checkAN">
                  Anschlussflug suchen
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="anschFLS">
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <h3 v-if="dataFSAN.res == 'fs'">
                    {{
                      dataFSAN.airline.name +
                      " - " +
                      flnAN +
                      " am " +
                      computedDateFormattedAN
                    }}
                  </h3>
                  <h3 v-if="dataFSAN.res == 'ma'">
                    {{ flnAN + " am " + computedDateFormattedAN }}
                  </h3>
                  <div class="text--primary">
                    <v-row v-if="dataFSAN.res == 'fs'">
                      <v-col cols="12" sm="6">
                        <v-icon>flight_takeoff</v-icon><br />
                        <h3>
                          {{
                            dataFSAN.airports.airportSName +
                            " (" +
                            dataFSAN.airports.airportSC +
                            ")"
                          }}
                        </h3>
                        <p>{{ fs4DisplayDepAN }}</p>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-icon>flight_land</v-icon><br />
                        <h3>
                          {{
                            dataFSAN.airports.airportTName +
                            " (" +
                            dataFSAN.airports.airportTC +
                            ")"
                          }}
                        </h3>
                        <p>{{ fs4DisplayArrAN }}</p>
                      </v-col>
                    </v-row>
                    <v-row v-if="dataFSAN.res == 'ma'">
                      <v-col cols="12" sm="6">
                        <v-autocomplete attach v-model="manDepAirAN" :items="airports5" :loading="isLoading"
                          :disabled="pass20" :search-input.sync="search5" color="blue-grey lighten-2"
                          label="Startflughafen" clearable flat item-text="fsidAN" item-value="data.item" hide-no-data
                          hide-details prepend-icon="flight_takeoff" return-object>
                          <template v-slot:item="data">
                            <template>
                              <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME
                                ">{{ data.item.FSID }} -
                                {{ data.item.airportNAME }}
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-autocomplete attach v-model="manArrAirAN" :items="airports6" :loading="isLoading"
                          :disabled="pass20" :search-input.sync="search6" color="blue-grey lighten-2"
                          label="Zielflughafen" clearable flat item-text="fsidAN" item-value="item" hide-no-data
                          hide-details prepend-icon="flight_land" return-object>
                          <template v-slot:item="data">
                            <template>
                              <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME
                                ">{{ data.item.FSID }} -
                                {{ data.item.airportNAME }}
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn id="confirm-data-fl--xtra" block @click="start20" :disabled="pass20" text
                    color="teal darken-1">
                    Anschlussflug bestätigen
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <v-row v-if="selectedDiv != '20'">
          <v-col cols="12">
            <v-btn block color="#dae0e5" class="mr-4" @click="start32" id="search-fl--new">Einen neuen Flug prüfen?
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div id="pass24" class="qam-calc-box" v-show="selectedDiv == '24' || pass24">
        <!-- <v-row>
          <v-col cols="12">
            <h3>
              Vielen Dank für Ihre Eingaben! Es kommen grundsätzlich
              verschiedene Anbieter in Betracht, die Fluggästen für die
              eingegebene Flugunregelmäßigkeit zu einer Entschädigung zu
              verhelfen. Um die Konditionen der Fluggastportale genauer zu
              vergleichen, bitten wir Sie noch um einige zusätzliche Angaben:
            </h3>
          </v-col>
          <v-col cols="12" sm="6">
            <p>
              Der Flug wurde zu einem öffentlich nicht verfügbaren Sondertarif
              gebucht (z.B. als Angestellter einer Fluggesellschaft).
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              attach
              v-model="data.selectMi"
              :items="itemsJN"
              :disabled="pass24"
              item-text="state"
              label="Trifft zu?"
            ></v-select>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="12" sm="6">
            <p>
              Wegen der angegebenen Flugunregelmäßigkeit wurde schon eine
              Entschädigung ausgezahlt oder ein Fluggastportal mit der
              Forderungsdurchsetzung beauftragt.
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectDi" :items="itemsJN" :disabled="pass24" item-text="state"
              label="Trifft zu?"></v-select>
          </v-col>
        </v-row>
        <v-row v-show="selectedDiv == '24'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="confirm-tarif-refund" block :disabled="data.selectMi == '' || data.selectDi == ''"
              color="success" class="mr-4" @click="check24">
              Weiter
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '24'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="goto--tarif-refund" block :disabled="data.selectMi == '' || data.selectDi == ''" color="#dae0e5"
              class="mr-4" @click="backToSpecificTile('24')">
              Zurück zu dieser Position
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div id="pass31" class="qam-calc-box" v-show="selectedDiv == '31' || pass31">
        <v-row>
          <v-col cols="12">
            <h3>
              Noch eine Frage: Hat Sie ein Ersatzflug von Ihrem Startflughafen
              aus befördert?
            </h3>
          </v-col>
          <v-col cols="12" sm="6">
            <p>
              Für meinen Flug {{ this.flN }} wurde mir ein
              <b>Ersatzflug</b> angeboten, der maximal zwei Stunden später als
              der ursprünglich gebuchte dessen Ziel erreichte.
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectedAlternativflug" :items="itemsJN" :disabled="pass31" item-text="state"
              label="Trifft das zu?" persistent-hint return-object single-line></v-select>
          </v-col>
        </v-row>

        <v-row v-show="selectedDiv == '31'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="confirm-notif-alt" block :disabled="data.selectedAlternativflug == ''" color="success"
              class="mr-4" @click="check31">
              Weiter
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '31'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="goto--notif-alt" block color="#dae0e5" class="mr-4" @click="backToSpecificTile('31')">
              Zurück zu dieser Position
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div id="pass33" class="qam-calc-box" v-show="selectedDiv == '33' || pass33">
        <v-row>
          <v-col cols="12">
            <h3>
              Sehr gut: Für die geschilderte Konstellation unterbreiten
              prinzipiell mehrere Fluggasthelfer Angebote zur Entschädigung.
              Bitte teilen Sie uns zur näheren Einschätzung noch mit, wie Sie
              von dem Flugausfall erfahren haben:
            </h3>
          </v-col>
          <v-col cols="12" sm="6">
            <p>
              Wann wurde die Flugstreichung bekanntgegeben (z.B. durch die
              Fluggesellschaft)?
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectIn" :items="itemsBenachrichtigt" :disabled="pass33" item-text="state"
              label="Wann wurden Sie benachichtigt?" persistent-hint single-line></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <p>
              Mir wurde für meinen Flug {{ this.flN }} eine Alternative
              angeboten (z.B. durch kostenlose Umbuchungsoption per Hotline oder
              App). Der Alternativflug startete höchstens eine Stunde früher und
              erreichte das Ziel höchstens zwei Stunden später als mein
              ursprünglicher Flug.
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectAl" :items="itemsJN" :disabled="pass33" item-text="state"
              label="Trifft zu?" persistent-hint single-line></v-select>
          </v-col>
        </v-row>
        <v-row v-show="selectedDiv == '33'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="confirm-notif-can" block :disabled="data.selectIn == '' || data.selectAl == ''" color="success"
              class="mr-4" @click="check33">
              Weiter
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '33'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="goto--notif-can" block color="#dae0e5" class="mr-4" @click="backToSpecificTile('33')">
              Zurück zu dieser Position
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div id="pass34" class="qam-calc-box" v-show="selectedDiv == '34' || pass34">
        <v-row>
          <v-col cols="12">
            <h3>
              Sehr gut: Für die geschilderte Konstellation unterbreiten
              prinzipiell mehrere Fluggasthelfer Angebote zur Entschädigung.
              Welche im Einzelnen in Frage kommen, richtet sich allerdings
              zusätzlich nach den genauen Umständen der Flugunregelmäßigkeit.
              Bitte teilen Sie uns deshalb mit, ob Sie zur regulären Startzeit
              abflugbereit waren:
            </h3>
          </v-col>
          <v-col cols="12" sm="6">
            <p>
              Ich habe rechtzeitig eingecheckt und bin ich trotz Verzögerung
              mitgeflogen.
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectedCheckIn451" :items="itemsJN" :disabled="pass34" item-text="state"
              label="Trifft das zu?" persistent-hint single-line></v-select>
          </v-col>
        </v-row>
        <v-row v-if="data.selectedCheckIn451 == 'Nein'">
          <v-col cols="12" sm="6">
            <p>
              Ich fand mich mehr als eine Stunde vor der geplanten Abflugszeit
              am Check-In-Schalter ein. Außerdem bin ich trotz Verzögerung
              mitgeflogen.
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectedCheckIn452" :items="itemsJN" :disabled="pass34" item-text="state"
              label="Trifft das zu?" persistent-hint single-line></v-select>
          </v-col>
        </v-row>

        <v-row v-show="selectedDiv == '34'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="confirm-checkin" block :disabled="data.selectedCheckIn451 == '' && data.selectedCheckIn452 == ''
              " color="success" class="mr-4" @click="check34">
              Weiter
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '34'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="goto--checkin" block color="#dae0e5" class="mr-4" @click="backToSpecificTile('34')">
              Zurück zu dieser Position
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div id="pass35" class="qam-calc-box" v-show="selectedDiv == '35' || pass35">
        <v-row>
          <v-col cols="12">
            <h3>
              Danke für die Eingaben. Nun noch eine letzte Frage, damit wir
              beurteilen können, welche Angebote von Fluggastportalen für Ihre
              Entschädigung möglich sind:
            </h3>
          </v-col>
          <template v-if="kiofCla == 'L' || kiofCla == 'VP'">
            <v-col cols="12" sm="6">
              <p>
                Erhielten Sie vom Piloten oder einem Crewmitglied Informationen
                zum Grund der Flugunregelmäßigkeit?
              </p>
            </v-col>

            <v-col cols="12" sm="6">
              <v-select attach v-model="data.selectedInfoCrew" :items="itemsJN" :disabled="pass35" item-text="state"
                label="Trifft das zu?" persistent-hint return-object single-line></v-select>
            </v-col>
          </template>
        </v-row>
        <v-row v-if="
          data.selectedInfoCrew.state == 'Nein' ||
          (kiofCla != 'L' && kiofCla != 'VP')
        ">
          <v-col cols="12" sm="6">
            <p>
              Erhielten Sie vom Kundendienst oder sonstigen Mitarbeitern der
              Airline Informationen zum Grund der Flugunregelmäßigkeit?
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectedInfoAirline" :items="itemsJN" :disabled="pass35" item-text="state"
              label="Trifft das zu?" persistent-hint return-object single-line></v-select>
          </v-col>
        </v-row>
        <v-row v-if="data.selectedInfoAirline.state == 'Nein'">
          <v-col cols="12" sm="6">
            <p>
              Haben Sie auf anderem Wege etwas zum Grund der
              Flugunregelmäßigkeit erfahren?
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select attach v-model="data.selectedInfoOther" :items="itemsJN" :disabled="pass35" item-text="state"
              label="Trifft das zu?" persistent-hint return-object single-line></v-select>
          </v-col>
        </v-row>
        <div v-if="
          data.selectedInfoOther.state == 'Ja' ||
          data.selectedInfoCrew.state == 'Ja' ||
          data.selectedInfoAirline.state == 'Ja' ||
          data.selectedInfoOther.state == 'Nein'
        ">
          <div class="text-center" justify="center">
            <v-item-group v-model="sCase" style="min-width: 100%;">
              <v-row>
                <v-col v-for="item in caseReason" :key="item" cols="12" md="3">
                  <v-item v-slot:default="{ active, toggle }">
                    <v-card :color="active ? '#3F677B' : ''" class="align-center" :disabled="pass35" dark height="80"
                      @click="toggle()">
                      <div style="padding-top: 30px;" class="text-center">
                        {{ item }}
                      </div>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
          </div>
          <v-textarea name="input-7-1" filled
            label="Bitte beschreiben Sie kurz, was Ihnen als Grund der Flugunregelmäßigkeit mitgeteilt wurde." auto-grow
            :disabled="pass35" value="" v-model="textReason"></v-textarea>
        </div>
        <v-row v-show="selectedDiv == '35'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="confirm-reas" block :disabled="textReason == ''" color="success" class="mr-4"
              @click="check35('NW')">
              Weiter
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '35'">
          <v-col offset-sm="6" cols="12" sm="6">
            <v-btn id="goto--reas" block color="#dae0e5" class="mr-4" @click="backToSpecificTile('35')">
              Zurück zu dieser Position
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-show="selectedDiv == '40' || pass40">
        <v-row>
          <v-col cols="12">
            <h2 class="qam-calc-h2">
              Ergebnis und Anbieterempfehlung
            </h2>
          </v-col>
        </v-row>
        <template v-if="shRE">
          <div id="restable" class="fion-bg-qam bg-white rounded p-7 marg-top-30 qam-shadow">
            <div class="row offer-row">
              <div class="col-12 text-center">
                <h2 v-html="offertext"></h2>
              </div>
            </div>
            <div class="row marg-0-0">
              <div class="col-sm-3 mb-2 mb-sm-0">
                <h5>Sortieren nach:</h5>
              </div>
              <div class="col-sm-3 mb-2 mb-sm-0 padd-0-0">
                <v-btn id="sort-offers--qam" class="btn qua-btn-sort btn-block" v-bind:class="{ active: isAQ }"
                  @click="bqb">
                  Qamqam-Bewertung
                </v-btn>
              </div>
              <div class="col-sm-3 mb-2 mb-sm-0 padd-0-0">
                <v-btn id="sort-offers--speed" class="btn qua-btn-sort btn-block" v-bind:class="{ active: isAS }"
                  @click="btf">
                  Am schnellsten
                </v-btn>
              </div>
              <div class="col-sm-3 mb-2 mb-sm-0 padd-0-0">
                <v-btn id="sort-offers--amt" class="btn qua-btn-sort btn-block" v-bind:class="{ active: isAM }"
                  @click="bvf">
                  Am meisten
                </v-btn>
              </div>
            </div>
          </div>
          <div id="pass40" class="qua-space-2-bottom">
            <ul class="list-unstyled mb-0 px-0">
              <li class="my-2" v-for="provedat in provedata" v-bind:value="provedat" v-bind:key="provedat.index">
                <div class="qua-info-v1 p-4 qam-shadow" href="#">
                  <span class="row justify-content-sm-between align-items-sm-center">
                    <div class="col-sm-4 col-lg-3 mb-2 mb-sm-0 qq-col-primary-calculater-left">
                      <template v-if="provedat.LinkLogo != null">
                        <img class="d-block qam-provider-img" v-bind:src="provedat.LinkLogo" alt="SVG Illustration" />
                      </template>
                      <template v-else>
                        <h5 class="qam-bold-text text-center">
                          {{ provedat.portalNAME }}
                        </h5>
                      </template>
                      <div class="col-xs-12 qq-text-calculater-left-h3 qua-space-06-top">
                        {{ provedat.PortalOrt }}
                      </div>
                      <div class="col-xs-12 qq-text-calculater-left-h3">
                        <a v-bind:href="provedat.Links" target="_blank">{{
                          provedat.PortalDomain_NoAff
                        }}</a>
                      </div>
                      <div class="col-xs-12 qq-text-calculater-center-h2 text-center qua-space-06-top">
                        <img class="bwe-img" v-bind:src="provedat.Sterne" alt="SVG Illustration" /><span
                          class="stars-text">
                          {{ provedat.BewertungGesamt }}</span>
                      </div>
                    </div>
                    <div class="col-sm-4 col-lg-6 qq-col-primary-calculater-center">
                      <div class="col-xs-12 qq-text-calculater-center-h2">
                        <span><img src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-feature.svg"
                            alt="SVG Illustration" class="info-image" /></span><b>{{ provedat.PortalInfo_1 }}</b>
                      </div>
                      <div class="col-xs-12 qq-text-calculater-center-h2">
                        <span><img src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-feature.svg"
                            alt="SVG Illustration" class="info-image" /></span><b>{{ provedat.PortalInfo_2 }}</b>
                      </div>
                      <div v-if="provedat.PortalInfo_3 != ''" class="col-xs-12 qq-text-calculater-center-h2">
                        <span><img src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-info.svg"
                            alt="SVG Illustration" class="info-image" />{{ provedat.PortalInfo_3 }}</span>
                      </div>
                      <div v-if="provedat.PortalInfo_4 != ''" class="col-xs-12 qq-text-calculater-center-h2">
                        <span><img src="https://www.qam-qam.com/wp-content/uploads/2019/06/rechner-icon-info.svg"
                            alt="SVG Illustration" class="info-image" />{{ provedat.PortalInfo_4 }}</span>
                      </div>
                      <div class="col-xs-12 qua-space-06-top">
                        <a v-bind:id="provedat.TriggerIDReport" v-bind:href="provedat.LinkIntern"
                          class="btn btn-block angebotbuttonzwei" role="button">
                          Zum Testbericht »
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-3 mb-2 mb-sm-0 provider-button-box qq-col-primary-calculater-right">
                      <div class="col-xs-12 qq-text-calculater-right-h1">
                        <b>Auszahlung</b>
                      </div>
                      <div class="col-xs-12 qq-text-calculater-right-h2">
                        <b>{{ provedat.Zahlungshoehe }}</b>
                      </div>
                      <div class="col-xs-12 qq-text-calculater-right-h3">
                        Flugentschädigung pP.
                      </div>
                      <div class="col-xs-12 qua-space-06-top">
                        <a v-bind:href="provedat.Links" v-bind:id="provedat.TriggerID" target="_blank"
                          v-on:click="saveSelectedProvider(provedat.portalNAME)"
                          class="btn-sm qua-btn-primary--cta btn-block" role="button">
                          Zum Anbieter »
                        </a>
                      </div>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </div>
      <rejection-tile></rejection-tile>
      <div>
        <v-row v-if="selectedDiv == '32'">
          <v-col cols="12">
            <v-btn block color="success" class="mr-4" @click="start32">Einen neuen Flug prüfen?
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </template>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import * as easings from "vuetify/es5/services/goto/easing-patterns";
import RejectionTile from "./RejectionTile.vue";

export default {
  name: "CoreTile",
  components: { RejectionTile },
  data: function () {
    return {
      dataFS: {},
      easings: Object.keys(easings),
      l4AN: false,
      l4ZB: false,
      flOODE: false,
      s1FC: false,
      activeColor: "#8f1622",
      dataFSAN: null,
      dataFSZB: null,
      search1: null,
      search2: null,
      search3: null,
      search4: null,
      search5: null,
      search6: null,
      airports1: [],
      airports2: [],
      airports3: [],
      airports4: [],
      airports5: [],
      airports6: [],
      progress: false,
      manArrAir: "",
      manDepAir: "",
      time1: null,
      time2: null,
      menu1: false,
      menu2: false,
      ppath: [],
      kiofCla: "L",
      textReason: "",
      pass20: false,
      pass24: false,
      pass33: false,
      pass34: false,
      pass35: false,
      pass31: false,
      pass40: false,
      caseReason: [
        "Technisches Problem",
        "Probleme mit Personal",
        "Anweisung der Flugsicherung",
        "Blitzschlag",
        "Vogelschlag",
        "Schlechtes Wetter",
        "Organisatorisches Problem",
        "Sonstiges",
      ],
      cases: [
        "Pünktlich",
        "Flugverspätung",
        "Flugausfall",
        "Nichtbeförderung",
        "Verpasster Anschlussflug",
      ],
      data: {
        case: "",
        selectMi: "Nein",
        selectDi: "",
        selectIn: "",
        selectAl: "",
        selectedInfoCrew: "",
        selectedInfoAirline: "",
        selectedInfoOther: "",
        selectedAlternativflug: "",
        selectedCheckIn451: "",
        selectedCheckIn452: "",
      },
      itemsJN: [{ state: "Ja" }, { state: "Nein" }],
      itemsBenachrichtigt: [
        { state: "Über eine Woche vor Abflug" },
        { state: "Weniger als eine Woche vor Abflug" },
        { state: "Erst am Startflughafen" },
      ],
      flD: "",
      pass1F: false,
      reason4Position: "",
      offertext: "",
      flDAN: "",
      flDZB: "",
      shRE: false,
      provedata: "",
      isLoading: false,
      dateFormatted: "",
      dateFormattedDD1: "",
      dateFormattedAD1: "",
      datepickerfln: false,
      dateMenuDep: false,
      dateMenuArr: false,
      passAN: false,
      passZB: false,
      isAQ: true,
      isAS: false,
      isAM: false,
      valid: true,
      manRunSs: false,
      sCase: "",
      depDate1: "",
      arrDate1: "",
      mdelay: "",
      dFSS: false,
      flN: "",
      flnAN: "",
      flnZB: "",
      anschFLS: false,
      zubiFLS: false,
      datepickerflnAN: false,
      datepickerflnZB: false,
      fs4DisplayDep: "",
      fs4DisplayArr: "",
      fs4DisplayDepAN: "",
      fs4DisplayArrAN: "",
      fs4DisplayDepZB: "",
      fs4DisplayArrZB: "",
      manArrAirAN: "",
      manDepAirAN: "",
      manArrAirZB: "",
      manDepAirZB: "",
      position: 300,
      startposition: 0,
      flnRules: [(v) => !!v || "Bitte geben Sie eine gültige Flugnummer ein"],
    };
  },
  watch: {
    flD() {
      this.dateFormatted = this.formatDate(this.flD);
    },
    flDAN() {
      this.dateFormatted = this.formatDate(this.flDAN);
    },
    flDZB() {
      this.dateFormatted = this.formatDate(this.flDZB);
    },
    depDate1() {
      this.dateFormattedDD1 = this.formatDate(this.depDate1);
    },
    arrDate1() {
      this.dateFormattedAD1 = this.formatDate(this.arrDate1);
    },
    search1() {
      this.findAirports("1");
    },
    search2() {
      this.findAirports("2");
    },
    search3() {
      this.findAirports("3");
    },
    search4() {
      this.findAirports("4");
    },
    search5() {
      this.findAirports("5");
    },
    search6() {
      this.findAirports("6");
    },
  },
  computed: {
    selectedDiv() {
      return this.$store.state.selectedDiv;
    },
    target() {
      const value = this.position;
      if (!isNaN(value)) return Number(value);
      else return value;
    },
    options() {
      return {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      };
    },
    computedDateFormatted() {
      return this.formatDate(this.flD);
    },
    computedDateFormattedAN() {
      return this.formatDate(this.flDAN);
    },
    computedDateFormattedZB() {
      return this.formatDate(this.flDZB);
    },
    computedDateFormattedDepDate() {
      return this.formatDate(this.depDate1);
    },
    computedDateFormattedArrDate() {
      return this.formatDate(this.arrDate1);
    },
  },
  mounted: function () {
    var manRun = sessionStorage.getItem("manRunSs");
    var flnFS = sessionStorage.getItem("flN");
    var fldFS = new Date(sessionStorage.getItem("flD"))
      .toISOString()
      .substring(0, 10);
    sessionStorage.clear();
    if (manRun == "0") {
      if (flnFS != null && fldFS != null) {
        this.flN = flnFS;
        this.flD = fldFS;
        this.dFSS = true;
        this.validate();
      }
    } else if (manRun == "1") {
      this.goToMan();
    }
  },
  methods: {
    ...mapActions(["setSelectedDiv"]),
    goToStep(val) {
      this.ppath.push(val);
      let step = 350;
      if (val == "pass40") {
        step = 500;
      }
      this.position = window.scrollY + step;
      this.$vuetify.goTo(this.target, this.options);
    },
    findAirports(val) {
      if (this["airports" + val].length > 0) return;
      this.isLoading = true;
      fetch(
        "https://www.qam-qam.com/wp-content/themes/qamqam%200.1/own/func/getAirportsNew.php"
      )
        .then((res) => res.json())
        .then((res) => {
          this["airports" + val] = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    parseDate4DisplayD(val) {
      const event = new Date(val);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return event.toLocaleDateString("de-DE", options);
    },
    parseDate4DisplayT(val) {
      const event = new Date(val);
      const optionst = {
        hour: "2-digit",
        minute: "2-digit",
      };
      return event.toLocaleTimeString("de-DE", optionst);
    },
    peek() {
      return this.ppath[this.ppath.length - 1];
    },
    async validate() {
      if (!this.manRunSs) {
        if (this.$refs.form.validate() || this.dFSS) {
          this.dataFS = await this.getFlightData(this.flN, this.flD);
          this.progress = true;
          if (this.dataFS.res == "fs") {
            if (
              this.dataFS.airports.airportSCC != "DE" &&
              this.dataFS.airports.airportTCC != "DE"
            ) {
              this.flOODE = true;
            }
            this.depDate1 = new Date(this.dataFS.departureDateLocal)
              .toISOString()
              .substr(0, 10);
            this.time1 = this.parseDate4DisplayT(this.dataFS.arrivalDateLocal);
            var ttime1 = this.parseDate4DisplayT(
              this.dataFS.departureDateLocal
            );
            this.arrDate1 = new Date(this.dataFS.arrivalDateLocal)
              .toISOString()
              .substr(0, 10);
            this.time2 = this.parseDate4DisplayT(this.dataFS.arrivalDateLocal);
            this.fs4DisplayDep =
              this.parseDate4DisplayD(this.dataFS.departureDateLocal) +
              " " +
              ttime1;
            this.fs4DisplayArr =
              this.parseDate4DisplayD(this.dataFS.arrivalDateLocal) +
              " " +
              this.time2;
            this.kiofCla = this.dataFS.status;
            switch (this.kiofCla) {
              case "P":
                this.data.case = "Pünktlich";
                break;
              case "L":
                this.data.case = "Flugverspätung";
                break;
              case "C":
                this.data.case = "Flugausfall";
                break;
              default:
                break;
            }
          }
        }
      }
      this.startposition = window.scrollY;
      this.progress = true;
      this.setSelectedDiv("20");
      this.goToStep(this.selectedDiv);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    confirmF1Flight() {
      switch (this.data.case) {
        case "Pünktlich":
          this.kiofCla = "P";
          this.setSelectedDiv("32");
          break;
        case "Flugverspätung":
          var dd = moment(this.depDate1);
          var ad = moment(this.arrDate1);
          var t1 = this.time1.split(":");
          var t2 = this.time2.split(":");
          dd.hour(t1[0]);
          dd.minute(t1[1]);
          ad.hour(t2[0]);
          ad.minute(t2[1]);
          this.mdelay = ad.diff(dd, "minutes");
          // if (this.mdelay <= 179) {
          //   this.kiofCla = "P";
          //   this.setSelectedDiv("32");
          // } else {
          this.kiofCla = "L";
          this.flDAN = this.flD;
          // }
          break;
        case "Flugausfall":
          this.kiofCla = "C";
          this.flDAN = this.flD;
          break;
        case "Nichtbeförderung":
          this.kiofCla = "NB";
          this.flDAN = this.flD;
          break;
        case "Verpasster Anschlussflug":
          this.kiofCla = "VP";
          this.flDAN = this.flD;
          break;
        default:
          break;
      }
      if (this.dataFS.res == "ma") {
        if (
          this.manDepAir.airportCOUC != "DE" &&
          this.manArrAir.airportCOUC != "DE"
        ) {
          this.flOODE = true;
        }
      }
      this.passAN = false;
      this.passZB = false;
      this.pass1F = true;
      if (this.flOODE) {
        this.flDZB = this.flD;
      }
    },
    start20() {
      this.progress = true;
      this.pass20 = true;
      this.passAN = true;
      this.passZB = true;
      this.l4AN = true;
      this.l4ZB = true;
      this.setSelectedDiv("24");
      this.goToStep(this.selectedDiv);
      this.updateVals();
    },
    start32() {
      this.setSelectedDiv("");
      this.position = this.startposition;
      this.$vuetify.goTo(this.target, this.options);
      this.pass1F = false;
      this.flOODE = false;
      this.manRunSs = false;
      this.manArrAirAN = "";
      this.manDepAirAN = "";
      this.manArrAirZB = "";
      this.manDepAirZB = "";
      this.shRE = false;
      this.offertext = "";
      this.flD = "";
      this.reason4Position = "";
      this.flDAN = "";
      this.flDZB = "";
      this.passAN = false;
      this.passZB = false;
      this.provedata = "";
      this.isLoading = false;
      this.dateFormatted = "";
      this.dateFormattedDD1 = "";
      this.dateFormattedAD1 = "";
      this.datepickerfln = false;
      this.dateMenuDep = false;
      this.dateMenuArr = false;
      this.valid = true;
      this.sCase = "";
      this.depDate1 = "";
      this.arrDate1 = "";
      this.mdelay = "";
      this.flN = "";
      this.flnAN = "";
      this.flnZB = "";
      this.anschFLS = false;
      this.zubiFLS = false;
      this.datepickerflnAN = false;
      this.datepickerflnZB = false;
      this.fs4DisplayDep = "";
      this.fs4DisplayArr = "";
      this.fs4DisplayDepAN = "";
      this.fs4DisplayArrAN = "";
      this.fs4DisplayDepZB = "";
      this.fs4DisplayArrZB = "";
      this.l4AN = false;
      this.l4ZB = false;
      this.s1FC = false;
      this.dataFSAN = null;
      this.search1 = null;
      this.search2 = null;
      this.search3 = null;
      this.search4 = null;
      this.search5 = null;
      this.search6 = null;
      this.progress = false;
      this.manArrAir = "";
      this.manDepAir = "";
      this.time1 = null;
      this.time2 = null;
      this.menu1 = false;
      this.menu2 = false;
      this.dFSS = false;
      this.ppath = [];
      this.textReason = "";
      this.kiofCla = "";
      this.ppath = [];
      this.pass20 = false;
      this.pass24 = false;
      this.pass33 = false;
      this.pass34 = false;
      this.pass35 = false;
      this.pass31 = false;
      this.pass40 = false;
      this.isAQ = true;
      this.isAS = false;
      this.isAM = false;
      this.data = {
        selectMi: "Nein",
        selectDi: "",
        selectIn: "",
        selectAl: "",
        selectedInfoCrew: "",
        selectedInfoAirline: "",
        selectedInfoOther: "",
        selectedAlternativflug: "",
        selectedCheckIn451: "",
        selectedCheckIn452: "",
      };
    },
    check24() {
      if (this.data.selectMi == "Nein" && this.data.selectDi == "Nein") {
        if (this.kiofCla == "C") {
          this.setSelectedDiv("33");
        } else if (this.kiofCla == "L") {
          this.setSelectedDiv("34");
        } else if (this.kiofCla == "NB") {
          this.setSelectedDiv("31");
        } else if (this.kiofCla == "VP") {
          this.setSelectedDiv("31");
        }
        this.pass24 = true;
      } else {
        this.reason4Position =
          "Ablehnung wegen bereits Entschädigt oder Mitarbeiter";
        this.setSelectedDiv("32");
      }
      this.goToStep(this.selectedDiv);
    },
    check31() {
      if (this.data.selectedAlternativflug != "Ja") {
        if (this.kiofCla == "NB") {
          this.setSelectedDiv("35");
        } else {
          this.setSelectedDiv("34");
        }
        this.pass31 = true;
      } else {
        this.setSelectedDiv("32");
        this.reason4Position = "Ablehnung wegen Pünktlich angekommen";
      }
      this.goToStep(this.selectedDiv);
    },
    check33() {
      if (
        (this.data.selectIn == "Weniger als eine Woche vor Abflug" ||
          this.data.selectIn == "Erst am Startflughafen") &&
        this.data.selectAl == "Nein"
      ) {
        this.setSelectedDiv("35");
        this.pass33 = true;
      } else {
        this.setSelectedDiv("32");
      }
      this.goToStep(this.selectedDiv);
    },
    check34() {
      if (
        this.data.selectedCheckIn451 == "Ja" ||
        this.data.selectedCheckIn452 == "Ja"
      ) {
        this.setSelectedDiv("35");
        this.pass34 = true;
      } else {
        this.reason4Position = "Ablehnung wegen Checkin";
        this.setSelectedDiv("32");
      }
      this.goToStep(this.selectedDiv);
    },
    check35(val) {
      this.setSelectedDiv("40");
      this.goToStep(this.selectedDiv);
      if (val != "FL") {
        this.getProv(this.sCase);
        this.pass35 = true;
      } else {
        this.getProv(0);
      }
    },
    async checkAN() {
      this.dataFSAN = await this.getFlightData(this.flnAN, this.flDAN);
      this.anschFLS = true;
      this.passAN = true;
      if (this.dataFSAN.res == "fs") {
        this.depDate1AN = new Date(this.dataFSAN.departureDateLocal)
          .toISOString()
          .substr(0, 10);
        this.time1AN = this.parseDate4DisplayT(
          this.dataFSAN.departureDateLocal
        );
        this.arrDate1AN = new Date(this.dataFSAN.arrivalDateLocal)
          .toISOString()
          .substr(0, 10);
        this.time2AN = this.parseDate4DisplayT(this.dataFSAN.arrivalDateLocal);
        this.fs4DisplayDepAN =
          this.parseDate4DisplayD(this.dataFSAN.departureDateLocal) +
          " " +
          this.time1AN;
        this.fs4DisplayArrAN =
          this.parseDate4DisplayD(this.dataFSAN.arrivalDateLocal) +
          " " +
          this.time2AN;
      }
    },
    async checkZB() {
      this.dataFSZB = await this.getFlightData(this.flnZB, this.flDZB);
      this.zubiFLS = true;
      this.s1FC = true;
      if (this.dataFSZB.res == "fs") {
        this.depDate1ZB = new Date(this.dataFSZB.departureDateLocal)
          .toISOString()
          .substr(0, 10);
        this.time1ZB = this.parseDate4DisplayT(
          this.dataFSZB.departureDateLocal
        );
        this.arrDate1ZB = new Date(this.dataFSZB.arrivalDateLocal)
          .toISOString()
          .substr(0, 10);
        this.time2ZB = this.parseDate4DisplayT(this.dataFSZB.arrivalDateLocal);
        this.fs4DisplayDepZB =
          this.parseDate4DisplayD(this.dataFSZB.departureDateLocal) +
          " " +
          this.time1ZB;
        this.fs4DisplayArrZB =
          this.parseDate4DisplayD(this.dataFSZB.arrivalDateLocal) +
          " " +
          this.time2ZB;
      }
    },
    setZB() {
      this.passZB = true;
    },
    sAN() {
      this.l4AN = true;
    },
    sZB(val) {
      if (val == "n") {
        this.passZB = true;
      }
      this.l4ZB = true;
    },
    killRun() {
      this.setSelectedDiv("32");
    },
    async getFlightData(flN, flD) {
      const data = await axios
        .post(
          "https://www.qam-qam.com/wp-content/themes/qamqam%200.1/own/func/getFlight.php",
          {
            flD: flD,
            flN: flN,
          }
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
      return data;
    },
    updateVals() {
      var go4ward = false;
      var startAirportCC, targetAirportCC = "";
      var startAirportIsEU, airIsEu = false;

      if (this.dataFS.res == "ma") {
        this.dataFS.airports = {};
        this.dataFS.airports.startAirport = this.manArrAir;
        this.dataFS.airports.targetAirport = this.manDepAir;

        this.dataFS.kiofCla = this.kiofCla;
        if (this.kiofCla == "L" || this.kiofCla == "VP") {
          this.dataFS.mdelay = this.mdelay;
        }
      }

      if (this.dataFSAN != null) {
        if (this.dataFSAN.res == "ma") {
          this.dataFSAN.airports = {};
          this.dataFSAN.airports.startAirport = this.manDepAirAN;
          this.dataFSAN.airports.targetAirport = this.manArrAirAN;
          this.dataFSAN.kiofCla = this.kiofCla;
          if (this.kiofCla == "L" || this.kiofCla == "VP") {
            this.dataFSAN.mdelay = this.mdelay;
          }
        }
      }

      if (this.dataFSZB != null) {
        if (this.dataFSZB.res == "ma") {
          this.dataFSZB.airports = {};
          this.dataFSZB.airports.startAirport = this.manDepAirZB;
          this.dataFSZB.airports.targetAirport = this.manArrAirZB;
          this.dataFSZB.kiofCla = this.kiofCla;
          if (this.kiofCla == "L" || this.kiofCla == "VP") {
            this.dataFSZB.mdelay = this.mdelay;
          }
        }
      }

      if (this.dataFSZB != null && this.dataFSAN == null) {
        startAirportCC =
          this.manDepAirZB == ""
            ? this.dataFSZB.airports.airportSCC
            : this.manDepAirZB.airportCOUC;
        targetAirportCC =
          this.manArrAir == ""
            ? this.dataFS.airports.airportTCC
            : this.manArrAir.airportCOUC;
        startAirportIsEU =
          this.manDepAirZB == ""
            ? this.dataFSZB.airports.SisEUAirport
            : this.switchVal(this.manDepAirZB.isEU);
      }

      if (this.dataFSZB == null && this.dataFSAN != null) {
        startAirportCC =
          this.manDepAirZB == ""
            ? this.dataFSZB.airports.airportSCC
            : this.manDepAirZB.airportCOUC;
        targetAirportCC =
          this.manArrAir == ""
            ? this.dataFS.airports.airportTCC
            : this.manArrAir.airportCOUC;
        startAirportIsEU =
          this.manDepAirZB == ""
            ? this.dataFSZB.airports.SisEUAirport
            : this.switchVal(this.manDepAirZB.isEU);
      }

      if (this.dataFSZB != null && this.dataFSAN != null) {
        startAirportCC =
          this.manDepAirZB == ""
            ? this.dataFSZB.airports.airportSCC
            : this.manDepAirZB.airportCOUC;
        targetAirportCC =
          this.manArrAirAN == ""
            ? this.dataFSAN.airports.airportTCC
            : this.manArrAirAN.airportCOUC;
        startAirportIsEU =
          this.manDepAirZB == ""
            ? this.dataFSZB.airports.SisEUAirport
            : this.switchVal(this.manDepAirZB.isEU);
      }

      if (this.mdelay <= 179) {
        go4ward = false;
      } else {
        go4ward = true;
      }

      if (
        startAirportCC == "DE" ||
        (targetAirportCC == "DE" && startAirportIsEU) || (targetAirportCC == "DE" && this.kiofCla == "TRF")
      ) {
        go4ward = true;
      } else if (targetAirportCC == "DE" && airIsEu) {
        go4ward = true;
      }

      if (go4ward) {
        axios
          .post(
            "https://www.qam-qam.com/wp-content/themes/qamqam%200.1/own/func/updateVals.php",
            {
              dataFS: this.dataFS,
              dataZB: this.dataFSZB,
              dataAN: this.dataFSAN,
              fstatus: this.kiofCla,
              delay: this.mdelay,
            }
          )
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            console.log(error);
            this.errored = true;
          })
          .finally(() => (this.loading = false));
      } else {
        this.goToStep(this.selectedDiv);
        this.setSelectedDiv("32");
      }
    },
    goToMan() {
      this.dataFS.res = "ma";
      this.manRunSs = true;
      this.validate();
    },
    getProv(val) {
      this.provedata = "";
      var targetAirport = null;
      if (this.anschFLS) {
        var tairFFS = {
          airportLAT: this.dataFS.airports.tlatitude,
          airportLON: this.dataFS.airports.tlongitude,
        };
        targetAirport = this.dataFSAN.res == "ma" ? this.manArrAirAN : tairFFS;
      } else if (!this.anschFLS && this.zubiFLS) {
        if (this.dataFS.res == "ma") {
          targetAirport = this.manArrAir;
        }
      }
      axios
        .post(
          "https://www.qam-qam.com/wp-content/themes/qamqam%200.1/own/func/getProviders.php",
          {
            targetf: targetAirport,
            reason: this.data.case,
            case: this.caseReason[val],
          }
        )
        .then((response) => {
          if (response.data.result == "AE") {
            this.setSelectedDiv("32");
          } else {
            this.shRE = true;
            this.provedata = response.data.data;
            if (this.dataFS.res == "fs") {
              var tempDate = this.dateFormatted;
              this.offertext =
                'Folgende Angebote zur Entschädigung kommen für Ihren Flug <span class="qam-link-color">' +
                this.flN +
                '</span> am <span class="qam-link-color">' +
                tempDate +
                "</span> in Betracht:";
            } else {
              var startAirport = this.manDepAir;
              var targetAirport = this.manArrAir;
              this.offertext =
                'Folgende Angebote zur Entschädigung kommen für Ihren Flug zwischen <span class="qam-link-color">' +
                startAirport.FSID +
                '</span> und <span class="qam-link-color">' +
                targetAirport.FSID +
                "</span> in Betracht:";
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    backToSpecificTile(pos) {
      while (this.peek() != pos) {
        let xy = this.ppath.pop();
        this["pass" + xy] = false;
      }
      this.setSelectedDiv(this.peek());
      this["pass" + this.selectedDiv] = false;
    },
    bqb() {
      this.isAQ = true;
      this.isAS = false;
      this.isAM = false;
      this.provedata = this.provedata.slice().sort(function (a, b) {
        return a.Gesamtbewertungrang - b.Gesamtbewertungrang;
      });
    },
    btf() {
      this.isAQ = false;
      this.isAS = true;
      this.isAM = false;
      this.provedata = this.provedata.slice().sort(function (a, b) {
        return a.Dauerbewertungrang - b.Dauerbewertungrang;
      });
    },
    bvf() {
      this.isAQ = false;
      this.isAS = false;
      this.isAM = true;
      this.provedata = this.provedata.slice().sort(function (a, b) {
        return a.Hoehebewertungrang - b.Hoehebewertungrang;
      });
    },
    switchVal(val) {
      if (val == true || val == "1") {
        return true;
      } else {
        return false;
      }
    },
    saveSelectedProvider(value) {
      axios
        .post(
          "https://www.qam-qam.com/wp-content/themes/qamqam%200.1/own/func/saveProvider.php",
          {
            provider: value,
          }
        )
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
